import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import PaymentBuilderWorkspace from "./PaymentBuilderWorkspace";
import ModalHeader from "../ModalButtons/ModalHeader";
import ReactPortalsRoot from '../ReactPortalsRoot/ReactPortalsRoot';
import ModalWarning from '../ModalWarning/ModalWarning'
import RefundForm from './RefundForm';
import MoveAmountAppliedForm from './MoveAmountAppliedForm';
import numeral from "numeral";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js';
import I18n from "i18n-js";
import { isEqual } from 'lodash';

class PaymentBuilder extends React.Component {

  constructor(props) {
    super(props)
    this.paymentBuilderRef = React.createRef()
    this.state = {
      activeTab: 'general',
      amount: this.props.payment_log.amount || 0,
      amount_refunded: this.props.payment_log.amount_refunded,
      customer: this.props.payment_log.customer || null,
      card: this.props.payment_log.card ? this.props.payment_log.card : null,
      cash_drawer_id: this.props.default_cash_drawer ? this.props.default_cash_drawer.id : '',
      payment_log_folios: this.setPaymentLogFolios(this.props),
      loading: false,
      payment_type: this.props.payment_type ? this.props.payment_type : "capture",
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null,
      },
      file_group: this.props.file_group,
      timeline: this.props.payment_log.timeline,
      displayRefundForm: false,
      refundFolioId: null,
      refundAmount: 0,
      displayMoveAmountForm: false,
      moveFromFolioId: null,
      moveToFolioId: null,
      moveAmount: 0,
      stripe: null,
      addNewCardVisible: typeof this.props.addNewCardVisible !== 'undefined' ? this.props.addNewCardVisible : false,
      disableNameOnCard: false,
      displayResetButton: false,
      incrementCardElementKey: false,
      redemption_code: '',
      voucher: null,
    };
    this.onChangeCustomer = this.onChangeCustomer.bind(this);
    this.onChangeCashDrawer = this.onChangeCashDrawer.bind(this);
    this.onChangePaymentDetails = this.onChangePaymentDetails.bind(this);
    this.onChangePaymentType = this.onChangePaymentType.bind(this);
    this.onChangeFolioField = this.onChangeFolioField.bind(this);
    this.onChangeNote = this.onChangeNote.bind(this);
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
    this.onChangeFlagged = this.onChangeFlagged.bind(this)
    this.onChangeCard = this.onChangeCard.bind(this);
    this.onChangeTabs = this.onChangeTabs.bind(this);
    this.onChangeIncidentalAmount = this.onChangeIncidentalAmount.bind(this);
    this.onClickCloseModal = this.onClickCloseModal.bind(this);
    this.onChangeAuthAmount = this.onChangeAuthAmount.bind(this);
    this.onChangeApplyAuthFolio = this.onChangeApplyAuthFolio.bind(this);
    this.onChangeApplyFoliosAmount = this.onChangeApplyFoliosAmount.bind(this);
    this.addAppliedFolio = this.addAppliedFolio.bind(this);
    this.removeAppliedFolio = this.removeAppliedFolio.bind(this);
  };

  async componentDidMount(){
    const stripe = await loadStripe(this.props.public_gateway_key);

    this.setState({stripe: stripe});
  };

  componentWillReceiveProps(nextProps){
    const paymentLogFolios = this.setPaymentLogFolios(nextProps);
    if (!isEqual(this.state.payment_log_folios, paymentLogFolios)) {
      this.setState({ payment_log_folios: paymentLogFolios });
    }
  };

  componentDidUpdate(){
    if (this.state.errors){
      window.scrollTo(0, 0);
    };
  };

  render() {
    
    return(
      <div className="payment-log PaymentBuilder" ref={this.paymentBuilderRef}>
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <div className="tab-content">
            {
              this.state.stripe
              ?
                <Elements
                  stripe={this.state.stripe}
                  options={{
                    locale: navigator.languages && navigator.languages.length
                      ? navigator.languages[0]
                      : navigator.language
                    }}
                >
                  <ElementsConsumer>
                    {({ stripe, elements }) => (
                      [
                        <PaymentBuilderWorkspace
                          key="paymentBuilderWorkspace"
                          {...this.props}
                          {...this.state}
                          cash_drawers={this.props.cash_drawers}
                          payment_log={this.props.payment_log}
                          payment_log_notes_path={this.props.payment_log_notes_path}
                          incidental_deposit_payment={this.props.incidental_deposit_payment}
                          incidental_deposit={this.props.incidental_deposit}
                          reservation_segment={this.props.reservation_segment}
                          activeTab={this.state.activeTab}
                          onChangeCustomer={this.onChangeCustomer}
                          new_record={this.props.new_record}
                          formatCurrency={this.formatCurrency}
                          onChangeCashDrawer={this.onChangeCashDrawer}
                          onChangeNote={this.onChangeNote}
                          onChangeFileUploadGroup={this.onChangeFileUploadGroup}
                          onChangeFlagged={this.onChangeFlagged}
                          onChangeFolioField={this.onChangeFolioField}
                          onChangePaymentDetails={this.onChangePaymentDetails}
                          onChangePaymentType={this.onChangePaymentType}
                          date_format={this.props.date_format}
                          time_format={this.props.time_format}
                          onChangeCard={this.onChangeCard}
                          onChangeIncidentalAmount={this.onChangeIncidentalAmount}
                          new_auth_payment={this.props.new_auth_payment}
                          onChangeAuthAmount={this.onChangeAuthAmount}
                          capture_auth={this.props.capture_auth}
                          folios={this.props.folios}
                          onChangeApplyAuthFolio={this.onChangeApplyAuthFolio}
                          onChangeApplyFoliosAmount={this.onChangeApplyFoliosAmount}
                          addAppliedFolio={this.addAppliedFolio}
                          removeAppliedFolio={this.removeAppliedFolio}
                          originalAuthAmount={this.props.capture_auth ? this.props.payment_log.amount : null}
                          onClickRefund={this.onClickRefund}
                          onClickChangeAmount={this.onClickChangeAmount}
                          toggleAddNewCard={this.toggleAddNewCard}
                          cardElementKeyIncremented={this.cardElementKeyIncremented}
                          onChange={this.onChange}
                          getVoucher={this.getVoucher}
                          onClickRefundVoucher={this.onClickRefundVoucher}
                          removeVoucher={this.removeVoucher}
                          payment_channel={this.props.payment_log.payment_channel ? this.props.payment_log.payment_channel : null}
                          buttons={this.setButtons(elements)}
                          imported_reservation={this.props.imported_reservation}
                        />,
                        (this.props.ignoreModalButtons ? null : <ModalButtons loading={this.state.loading} buttons={this.setButtons(elements)} key="ModalButtons" />)
                      ]
                    )}
                  </ElementsConsumer>
                </Elements>
              : 
              null
            }

            <LoadingSpinner show={this.state.loading} />

            <ModalHeader onClick={this.onClickCloseModal} triggerUpdate />
          </div>
        </div>
        {
          this.state.displayRefundForm && this.state.refundFolioId
            ?
            <ReactPortalsRoot
              children={[
                <ModalWarning
                  key="body"
                  title={I18n.t('refund_folio') + ': ' + this.state.payment_log_folios.find(plf => plf.folio_id === this.state.refundFolioId).name}
                  body={
                    <RefundForm
                      date_format={this.props.date_format}
                      time_format={this.props.time_format}
                      paymentLogFolio={this.state.payment_log_folios.find(plf => plf.folio_id === this.state.refundFolioId)}
                      folioBalance={this.props.folios.find(folio => folio.id === this.state.refundFolioId).balance}
                      refundAmount={this.state.refundAmount}
                      onChangeRefundAmount={this.onChangeRefundAmount}
                      loading={this.state.loading}
                    />
                  }
                  CancelSubmit
                  onSubmit={this.refund}
                  onCancel={() => this.setState({ displayRefundForm: false })}
                />,

              ]
              }
              wrapperClassNames="ModalWarningWrapper"
            />
            :
            null
        }
        {
          this.state.displayRefundForm && this.state.refundVoucherID
            ?
            <ReactPortalsRoot
              children={[
                <ModalWarning
                  key="body"
                  title={I18n.t('refund_voucher') + ': ' + this.props.payment_log.vouchers.find(voucher => voucher.id === this.state.refundVoucherID).redemption_code}
                  body={
                    <RefundForm
                      date_format={this.props.date_format}
                      time_format={this.props.time_format}
                      paymentLogVoucher={this.props.payment_log.vouchers.find(voucher => voucher.id === this.state.refundVoucherID)}
                      refundAmount={this.state.refundAmount}
                      onChangeRefundAmount={this.onChangeRefundAmount}
                      previouslyRefundedToPayment={this.props.payment_log.amount_refunded}
                      paymentTotal={this.props.payment_log.amount}
                      loading={this.state.loading}
                    />
                  }
                  CancelSubmit
                  onSubmit={this.refund}
                  onCancel={() => this.setState({ displayRefundForm: false })}
                />,

              ]
              }
              wrapperClassNames="ModalWarningWrapper"
            />
            :
            null
        }
        {
          this.state.displayMoveAmountForm && this.state.moveFromFolioId
            ?
            <ReactPortalsRoot
              children={[
                <ModalWarning
                  key="body"
                  title={I18n.t('move_from') + ':' + this.state.payment_log_folios.find(plf => plf.folio_id === this.state.moveFromFolioId).name}
                  body={
                    <MoveAmountAppliedForm
                      errors={this.state.errors}
                      date_format={this.props.date_format}
                      time_format={this.props.time_format}
                      paymentLogFolio={this.state.payment_log_folios.find(plf => plf.folio_id === this.state.moveFromFolioId)}
                      moveAmount={this.state.moveAmount}
                      payment_log_id={this.props.payment_log.id}
                      loading={this.state.loading}
                      onChangeFolio={this.onChangeFolio}
                      onChangeMoveAmount={this.onChangeMoveAmount}
                      cashPayment={this.props.payment_log.cash_drawer ? true : false}
                    />
                  }
                  CancelSubmit
                  onSubmit={this.moveAmount}
                  onCancel={() => this.setState({ displayMoveAmountForm: false, errors: [] })}
                />,

              ]
              }
              wrapperClassNames="ModalWarningWrapper"
            />
            :
            null
        }
      </div>
    );
  };

  setButtons = (elements) => {
    this.elements = elements;    
    if ((this.props.new_record || this.props.capture_auth) && this.state.displayResetButton) {
      var buttons = [
        {
          name: I18n.t('reset'),
          button_classes: ['primary', 'modal-footer', 'btn-primary', 'reset_button'],
          onClick: (e) => {
            this.setState({ incrementCardElementKey: true})
          }
        },
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ],
          onClick: (e) => {
            window.parent.$(window.parent).trigger("folioItemSavedSuccessfully")
            parent.refresh_data()
            parent.hide_modal()
          }
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons, btn-primary'],
          onClick: (e) => {
              this.save(e, elements);
          }
        },
      ];
    } else if(this.props.new_record || this.props.capture_auth) {
      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ],
          onClick: (e) => {
            window.parent.$(window.parent).trigger("folioItemSavedSuccessfully")
            parent.refresh_data()
            parent.hide_modal()
          }
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons, btn-primary'],
          onClick: (e) => {
              this.save(e, elements);
          }
        },
      ];
    }

    else {
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ],
          onClick: (e) => {
            parent.refresh_data();
            parent.hide_modal();
          }
        },
      ];
    };
    return buttons
  };

  tabs() {
    const { showNotesTab = true } = this.props;
    var tabs = [{
      tabName: I18n.t('general'),
      targetName: 'general',
      classes: this.state.activeTab === 'general' ? 'active' : null,
      changeHandler: this.onChangeTabs,
    }]

    if (showNotesTab) {
      tabs = [...
        tabs,
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.activeTab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeTabs,
        }
      ]
    }
    
    return tabs;
  };

  cardElementKeyIncremented = () => {
    this.setState({ incrementCardElementKey: false, errors: {}, disableNameOnCard: false, displayResetButton: false})
  };

  setPaymentLogFolios(props){
    if (props.capture_auth && props.payment_log.payment_log_folios){
      var plfs = props.payment_log.payment_log_folios.map((plf)=>{
        plf.id = this.generateId()
        return plf
      });
      return plfs
    } else if(props.payment_log.payment_log_folios){
      return props.payment_log.payment_log_folios
    } else {
      return null
    };
  };

  onChange = (e) => {
    
    const updatedState = Object.assign({}, this.state);
    updatedState[e.target.name] = e.target.value;
    this.setState(updatedState);
  };

  onClickCloseModal(){
    parent.refresh_data();
    parent.hide_modal();
  };

  onChangeTabs(tab) {
    this.setState({activeTab: tab});
  };

  onChangeCashDrawer(e) {
    this.setState({cash_drawer_id: e.target.value});
  }

  onChangePaymentType(e) {
    this.setState({ payment_type: e.target.value});
  }

  onChangePaymentDetails(e) {
    var card = Object.assign({}, this.state.card);
      e.target.name === 'save_card' ? card[e.target.name] = e.target.checked : card[e.target.name] = e.target.value;
      this.setState({card: card});
  };

  onChangeAuthAmount(amount){
    this.setState({amount: amount});
  };

  onChangeApplyAuthFolio(e){
    var plfs = JSON.parse(JSON.stringify(this.state.payment_log_folios))

    var updatedPlfs = plfs.map((plf => {
      if(plf.id === e.target.name){
        plf.folio_id = e.target.value;
        plf.folio_balance = this.props.folios.find(folio => folio.id === e.target.value).balance
        plf.settled = false
      };
      return plf
    }));

    this.setState({payment_log_folios: updatedPlfs});
  };

  onChangeCard(cardId) {
    if (this.state.customer && this.state.customer.cards) {
      var card = this.state.customer.cards.find(card => card.id === cardId);
    }
    
    this.setState({
      card: card,
    });
  };

  onChangeFileUploadGroup(file_upload_group) {
    this.setState({file_upload_group: file_upload_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event.target.checked
    this.setState({note_obj: note_obj});
  }

  onChangeFolioField(value, id){
    var updatedPLFS = this.state.payment_log_folios.map((plf) => {
      if (plf.folio_id === id){
        if (typeof value === 'boolean'){
          plf.settled = value;
        } else{
          plf.amount = plf.folio_balance < value ? plf.folio_balance : value;
          if (plf.amount < plf.folio_balance){
            plf.settled = false;
          };
        };
      };
      return plf
    });
    this.setState({
      payment_log_folios: updatedPLFS,
      amount: this.calculateAmount(updatedPLFS),
    });
  };

  onChangeApplyFoliosAmount(value, id){
    var plfs = JSON.parse(JSON.stringify(this.state.payment_log_folios))
    var updatedPlfs = plfs.map((plf => {
      if (plf.id === id) {
        plf.amount = value;
        if (plf.amount != plf.folio_balance) {
          plf.settled = false;
        };
      };
      return plf;
    }));

    this.setState({ payment_log_folios: updatedPlfs, amount: this.calculateAmount(updatedPlfs) });
  };

  onSettleApplyAuthFolios(value){
    var plfs = JSON.parse(JSON.stringify(this.state.payment_log_folios))

    var updatedPlfs = plfs.map((plf => {
      if (plf.id === id) {
        plf.settled = value;
      };
      return plf;
    }));

    this.setState({ payment_log_folios: updatedPlfs });
  };

  addAppliedFolio(){
    var updatedPlfs = JSON.parse(JSON.stringify(this.state.payment_log_folios));
    updatedPlfs.push({id: this.generateId(), folio_id: null, amount: 0, settled: false});
    this.setState({payment_log_folios: updatedPlfs});
  };

  removeAppliedFolio(e){
    var plfs = JSON.parse(JSON.stringify(this.state.payment_log_folios));
    var updatedPlfs = plfs.filter(plf => plf.id != e.target.name);
    this.setState({ payment_log_folios: updatedPlfs, amount: this.calculateAmount(updatedPlfs)})
  };

  removeVoucher = () => {
    this.setState({voucher: null, redemption_code: ''});
  };

  toggleAddNewCard = () => {
    this.state.addNewCardVisible
    ?
    this.setState({addNewCardVisible: false, card: null})
    :
    this.setState({addNewCardVisible: true, card: {save_card: true}})
  };

  onChangeCustomer(customer) {
    var defaultCard = customer && customer.cards && customer.cards.length  ? customer.cards.find(card => card.default) : null
    if(customer && customer.id){
      this.setState({
        customer: customer,
        card: defaultCard ? defaultCard : !customer.cards.length ? { save_card: false } : null
      }, () => {
        if (typeof this.props.onChangeCustomer === 'function') {
          this.props.onChangeCustomer(customer);
        }
      });
    } else {
      this.setState({
        customer: null,
        card: null,
      }, () => {
        if (typeof this.props.onChangeCustomer === 'function') {
          this.props.onChangeCustomer(null);
        }
      });
    };
  };

  onChangeIncidentalAmount(value) {
    this.setState({
      amount: value,
    });
  };

  onClickRefund = (e, folioId) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ refundFolioId: folioId, displayRefundForm: true });
  };

  onClickRefundVoucher = (e, voucherID) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ refundVoucherID: voucherID, displayRefundForm: true });
  };

  onChangeRefundAmount = (amount) => {
    this.setState({refundAmount: amount})
  };

  refund = () => {
    this.setState({ loading: true });

    $.ajax({
      type: 'POST',
      url: '/admin/payment-logs/process_refund',
      data: {
        id: this.props.payment_log.id,
        folio_id: this.state.refundFolioId,
        voucher_id: this.state.refundVoucherID,
        amount: this.state.refundAmount,
      },
    }).done((response) => {
      if (response.errors) {
        this.setState({
          loading: false,
          errors: response.errors,
        });
      } else {
        if (this.state.refundVoucherID) {
          this.setState({
            timeline: response.payment_log.timeline,
            amount_refunded: response.payment_log.amount_refunded,
            displayRefundForm: false,
            loading: false,
            refundAmount: 0,
          });
        } else {
          this.setState({
            payment_log_folios: response.payment_log.payment_log_folios,
            timeline: response.payment_log.timeline,
            amount_refunded: response.payment_log.amount_refunded,
            displayRefundForm: false,
            loading: false,
            refundAmount: 0,
          });
        };
      };
    });
  };

  onClickChangeAmount = (e, folioId) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ moveFromFolioId: folioId, displayMoveAmountForm: true });
  };

  onChangeMoveAmount = (amount) => {
    this.setState({ moveAmount: amount });
  };

  onChangeFolio = (folio) => {
    this.setState({ moveToFolioId: folio.id });
  };

  moveAmount = () => {
    this.setState({ loading: true });

    $.ajax({
      type: 'POST',
      url: '/admin/payment-logs/process_move_folio',
      data: {
        id: this.props.payment_log.id,
        folio_id: this.state.moveFromFolioId,
        amount: this.state.moveAmount,
        move_to_folio: this.state.moveToFolioId,
      },
    }).done((response) => {
      if (response.errors) {
        this.setState({
          loading: false,
          errors: response.errors,
        });
      } else {
        this.setState({
          payment_log_folios: response.payment_log.payment_log_folios,
          timeline: response.payment_log.timeline,
          displayMoveAmountForm: false,
          loading: false,
          moveAmount: 0,
        });
      };
    });
  };

  save = async (e, elements) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    };

    if (!this.state.customer && !this.props.customerOptional){
      this.setState({errors: {
        header_errors: [I18n.t('customer_cannot_be_blank')],
        field_errors: { customer: [I18n.t('cannot_be_blank')] },
      }});
      return;
    };

    if ((this.state.card && this.state.card.id) || (!this.state.addNewCardVisible && (this.state.customer && this.state.customer.cards && this.state.customer.cards.length)) || this.state.payment_type == 'cash' || this.state.payment_type == 'voucher' || this.state.payment_type == 'system_import'){
      this.confirmPayment();
    } else if (this.state.addNewCardVisible || this.props.customerOptional || this.state.customer.cards.length == 0){
      if (this.state.card && this.state.card.name_on_card && ((this.state.amount && this.state.amount > 0) || (this.props.order && this.props.order.total_amount > 0))) {
        var stripe = this.state.stripe;
        var cardElement = elements.getElement(CardElement);

        if (!stripe || !elements) {
          console.log('We should never hit this! Either Stripe or Elements is not loaded!')
          return;
        }

        const result = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement,
          billing_details: {
            name: this.state.card.name_on_card,
          },
        });

        this.setState({disableNameOnCard: true, displayResetButton: true})

        if(result.error) {
          var errors = {
            header_errors: [result.error.message],
            field_errors: { card_validation_error: result.error.message},
          };

          this.setState({errors: errors}, () => {
            if (typeof this.props.onPaymentErrors === 'function') {
              this.props.onPaymentErrors(errors);
            }
          })
        } else if (result.paymentMethod) {
          this.confirmPayment(result.paymentMethod)
        }
      } else {
        var errors = {
          header_errors: [],
          field_errors: {},
        }

        if (!this.state.card || !this.state.card.name_on_card) {
          errors.header_errors.push(I18n.t('name_on_card_error'))
          errors.field_errors.name_on_card_error = I18n.t('name_on_card_error')
        };

        if ((!this.props.order && (!this.state.amount || this.state.amount <= 0)) || (this.props.order && this.props.order.total_amount <= 0)) {
          errors.header_errors.push(I18n.t('amount_must_be_greater_than_zero'))
          errors.field_errors.amount_must_be_greater_than_zero = I18n.t('amount_must_be_greater_than_zero')
        };

        this.setState({errors: errors}, () => {
          if (typeof this.props.onPaymentErrors === 'function') {
            this.props.onPaymentErrors(errors);
          }
        });
      };
    };
  };

  confirmPayment = (token=null) => {
    if (this.state.note_obj.note) {
      var note_obj = this.state.note_obj
    };

    this.setState({ loading: true });

    const endpoint_url = this.endPointURL()
    
    $.ajax({
      type: 'POST',
      url: endpoint_url,
      data: {
        payment_log: {
          id: this.props.payment_log.id,
          amount: this.props.order ? this.props.order.total_amount : this.state.amount,
          card_id: this.state.card && this.state.card.id ? this.state.card.id : null,
          customer_id: this.state.customer ? this.state.customer.id : null,
          notes: this.state.notes,
          reservation_id: this.props.reservation_segment ? this.props.reservation_segment.reservation_id : null,
          reservation_segment_id: this.props.reservation_segment ? this.props.reservation_segment.id : null,
          order_id: this.props.order ? this.props.order.id : null,
        },
        voucher_id: this.state.voucher ? this.state.voucher.id : null,
        payment_token: token,
        save_card: this.state.card && this.state.card.save_card ? this.state.card.save_card : null,
        cash_drawer_id: this.state.cash_drawer_id,
        amount: this.props.order ? this.props.order.total_amount : this.state.amount,
        payment_log_folios: this.state.payment_log_folios ? JSON.stringify(this.state.payment_log_folios) : null,
        payment_type: this.state.payment_type ? this.state.payment_type : null,
        note: note_obj || null,
        file_group_files: this.state.file_group && this.state.file_group.file_uploads ? this.state.file_group.file_uploads.map(file => file.id) : null,
      },
    }).done((data) => {
      if (typeof this.props.onPaymentErrors === 'function') {
        this.props.onPaymentErrors(data);
      }

      if (data.errors && data.errors.header_errors.length) {
        this.setState({ loading: false, errors: data.errors }, this.paymentBuilderRef.current.scrollTo(0, 0));
      } else {
        parent.refresh_data()
        parent.hide_modal()
      };
    });
  };

  endPointURL = () => {
    if(this.state.payment_type == 'voucher'){
      return this.props.create_voucher_payment_path
    } else if (this.props.incidental_deposit_payment) {
      return '/admin/payment-logs/authorize_incidental_deposit'
    } else if (this.props.capture_auth) {
      return '/admin/payment-logs/capture_auth'
    } else {
      return '/admin/payment_logs'
    };
  };

  getVoucher = () => {
    
    $.ajax({
      type: 'POST',
      url: this.props.redeem_voucher,
      data: {
        voucher: {
          redemption_code: this.state.redemption_code,
        },
      },
    }).done((response) => {
      
      if (response.errors && Object.keys(response.errors).length > 0) {
        
        this.setState({
          errors: response.errors
        })
      } else {
        if(response.id) {
          this.setState({voucher: response})
        }
      }
    });
  };

  calculateAmount(plfs){
    return plfs.reduce((acc, plf) =>{
      return acc += plf.amount
    }, 0);
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    };

    return '-' + text;
  };

};

export default PaymentBuilder

